import ResultDetail from './ResultDetail.vue';

export default ResultDetail;
